var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Records Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6571 2C28.6571 0.895431 27.7616 0 26.6571 0H20.4573H17.3429C16.2384 0 15.3429 0.895431 15.3429 2V42C15.3429 43.1046 16.2384 44 17.3429 44H20.4573H26.6571C27.7616 44 28.6571 43.1046 28.6571 42V33H23.8521C22.7475 33 21.8521 32.1046 21.8521 31V13C21.8521 11.8954 22.7475 11 23.8521 11H28.6571V2Z",
    fill: "#C7CCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V42C0 43.1046 0.895431 44 2 44H5.11431H11.3141C12.4187 44 13.3141 43.1046 13.3141 42V33H8.50913C7.40456 33 6.50913 32.1046 6.50913 31V13C6.50913 11.8954 7.40456 11 8.50913 11H13.3141V2C13.3141 0.895431 12.4187 0 11.3141 0H5.11431H2Z",
    fill: "#C7CCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6859 42C30.6859 43.1046 31.5813 44 32.6859 44H35.8002H42C43.1046 44 44 43.1046 44 42V33H39.195C38.0904 33 37.195 32.1046 37.195 31V13C37.195 11.8954 38.0904 11 39.195 11H44V2C44 0.895431 43.1046 0 42 0H35.8002H32.6859C31.5813 0 30.6859 0.895431 30.6859 2V42Z",
    fill: "#C7CCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3141 22V11H8.50913C7.40456 11 6.50913 11.8954 6.50913 13V31C6.50913 32.1046 7.40456 33 8.50913 33H13.3141V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6571 22V11H23.8521C22.7475 11 21.8521 11.8954 21.8521 13V31C21.8521 32.1046 22.7475 33 23.8521 33H28.6571V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 33V22V11H39.195C38.0904 11 37.195 11.8954 37.195 13V31C37.195 32.1046 38.0904 33 39.195 33H44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6571 1C27.2093 1 27.6571 1.44772 27.6571 2V10H23.8521C22.1952 10 20.8521 11.3431 20.8521 13V31C20.8521 32.6569 22.1952 34 23.8521 34H27.6571V42C27.6571 42.5523 27.2093 43 26.6571 43H20.4573H17.3429C16.7907 43 16.3429 42.5523 16.3429 42V2C16.3429 1.44771 16.7907 1 17.3429 1H20.4573H26.6571ZM23.8521 12H27.6571V22V32H23.8521C23.2998 32 22.8521 31.5523 22.8521 31V13C22.8521 12.4477 23.2998 12 23.8521 12ZM1 2C1 1.44771 1.44772 1 2 1H5.11431H11.3141C11.8664 1 12.3141 1.44772 12.3141 2V10H8.50913C6.85227 10 5.50913 11.3431 5.50913 13V31C5.50913 32.6569 6.85227 34 8.50913 34H12.3141V42C12.3141 42.5523 11.8664 43 11.3141 43H5.11431H2C1.44772 43 1 42.5523 1 42V2ZM8.50913 12H12.3141V22V32H8.50913C7.95684 32 7.50913 31.5523 7.50913 31V13C7.50913 12.4477 7.95684 12 8.50913 12ZM32.6859 43C32.1336 43 31.6859 42.5523 31.6859 42V2C31.6859 1.44771 32.1336 1 32.6859 1H35.8002H42C42.5523 1 43 1.44772 43 2V10H39.195C37.5382 10 36.195 11.3431 36.195 13V31C36.195 32.6569 37.5382 34 39.195 34H43V42C43 42.5523 42.5523 43 42 43H35.8002H32.6859ZM39.195 12H43V22V32H39.195C38.6427 32 38.195 31.5523 38.195 31V13C38.195 12.4477 38.6427 12 39.195 12Z",
    stroke: "#C7CCCA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecords);
export default __webpack_public_path__ + "static/media/icon_records.034527dfaadf66da02edc057c02a741b.svg";
export { ForwardRef as ReactComponent };